// Add your custom JS here.

jQuery(window).on('scroll', function() {
    if (jQuery(window).scrollTop() >= 200) {
        jQuery('.header-part').addClass('sticky');
    } else {
        jQuery('.header-part').removeClass('sticky');
    }
});